import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import config from '.';

const app = initializeApp(config.firebase);
const messaging = getMessaging(app);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { app, messaging, auth, provider };
